const _excluded = ["productId", "toolId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { HeadlessTabTitle } from './HeadlessTabTitle';
import { useUnsafeCurrentProductId, useUnsafeCurrentToolId } from '../helpers/ProvidersContexts';
export const TabTitle = _ref => {
  let {
      productId,
      toolId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const connectedProductId = useUnsafeCurrentProductId();
  const connectedToolId = useUnsafeCurrentToolId();
  return /*#__PURE__*/React.createElement(HeadlessTabTitle, _extends({
    productId: productId || connectedProductId,
    toolId: toolId || connectedToolId
  }, props));
};
//# sourceMappingURL=TabTitle.js.map